import { Box, Container, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { PATHS } from 'src/appConfig/paths';
import { Button } from 'src/components/common';
import { setSelectedLink, setSelectedLinkName } from 'src/redux/common/commonSlice';
import { Navigator } from 'src/services';
import { FallbackProps } from '../CustomErrorBoundary';

const DefaultErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
  showErrorMessage = false,
}) => {
  const dispatch = useDispatch();
  const handleBackToHome = () => {
    resetErrorBoundary();

    // dispatch(setSelectedLink(PATHS.dashboard));
    // dispatch(setSelectedLinkName('Dashboard'));
    // Navigator.navigate(PATHS.root);
  };

  const handleTryAgain = () => {
    // resetErrorBoundary();
    window.location.reload();
  };

  return (
    <Container>
      <Box minHeight="70vh" pt={8} textAlign="center">
        <Typography variant="h1">Unfortunately, something went wrong.</Typography>
        <Typography mt={4}>
          Please refresh your browser. If the error continues, please contact our support team.
        </Typography>

        {showErrorMessage && (
          <Box mt={4}>
            <pre>{error.message}</pre>
          </Box>
        )}

        <Stack direction="row" alignItems="center" justifyContent="center" mt={4} spacing={3}>
          <Button onClick={handleBackToHome}>Back</Button>
          <Button onClick={handleTryAgain} variant="outline">
            Refresh page
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default DefaultErrorFallback;
